import { createContext, use } from 'react';
import { type AuthState } from '@packages/auth';

export type { AuthState };

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const context = use(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
